import { Form, Formik } from "formik";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import * as Yup from 'yup';
import InvitesState from "../Context/state";


const ModalCreateInivtes = ({ invitesDialog, hideDialog }) => {
    const { CreateInvites, plans } = InvitesState()

    const UserSchema = Yup.object().shape({
        email: Yup.string().email('Email inválido')
            .required('Campo Obrigatório'),
        planId: Yup.number().required('Campo Obrigatório'),
    });


    return (
        <Dialog visible={invitesDialog} style={{ width: '450px' }} header="Criar convite" modal className="p-fluid" onHide={hideDialog}>
            <Formik validationSchema={UserSchema} initialValues={{ email: "", planId: ""}} onSubmit={(values) => {
                CreateInvites(values, hideDialog);
            }}>
                {({ values, handleChange, errors, touched, handleSubmit }) => {
                    return (
                        <Form onSubmit={handleSubmit}>
                            <div className="field">
                                <label htmlFor="name">Email</label>
                                <InputText name="email" id="name" value={values?.email} onChange={handleChange} required autoFocus className={classNames({ 'p-invalid': errors.email && touched.email })} />
                                {errors.email && touched.email && <small className="p-invalid">{errors.email}</small>}
                            </div>
                            <div className="field">
                                <label htmlFor="name">Plano</label>
                                <Dropdown value={values?.planId} defaultValue={values?.planId} name="planId" onChange={handleChange} optionValue="id" options={plans} optionLabel="name"
                                    placeholder="Selecione o plano" className={classNames({ 'p-invalid': errors.planId && touched.planId })} />
                                {errors.planId && touched.planId && <small className="p-invalid">{errors.planId}</small>}

                            </div>
                            {/* <div className="field">
                                <label htmlFor="name">Nº de Zonas</label>
                                <InputNumber showButtons name="numberZones" id="numberZones" value={values?.numberZones} onValueChange={handleChange} required autoFocus className={classNames({ 'p-invalid': errors.numberZones && touched.numberZones })} />
                                {errors.numberZones && touched.numberZones && <small className="p-invalid">{errors.numberZones}</small>}
                            </div>
                            <div className="field">
                                <label htmlFor="name">Tamanho máximo</label>
                                <InputNumber showButtons name="maxSize" id="maxSize" value={values?.maxSize} onValueChange={handleChange} required autoFocus className={classNames({ 'p-invalid': errors.maxSize && touched.maxSize })} />
                                {errors.maxSize && touched.maxSize && <small className="p-invalid">{errors.maxSize}</small>}
                            </div> */}
                            <div className="p-5"></div>
                            <div className="flex align-items-center justify-content-end">
                                <div className=" w-6 flex align-items-center justify-content-end">
                                    <Button label="Cancel" type="button" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
                                    <Button label="Save" type="submit" icon="pi pi-check" className="p-button-text" />
                                </div>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </Dialog>
    )
}

export default ModalCreateInivtes